import { MDCDrawer } from "@material/drawer";
import { MDCTopAppBar } from '@material/top-app-bar';

const props = {
    navigationMarker: '.marker-main-navigation'
};

export function initNavigation() {
    if ($(props.navigationMarker).length) {
        const drawer = new MDCDrawer(document.querySelector('.mdc-drawer'));
        const topAppBar = new MDCTopAppBar(document.getElementById('app-bar'));

        topAppBar.setScrollTarget(document.getElementById('main-content'));
        topAppBar.listen('MDCTopAppBar:nav', () => {
            drawer.open = !drawer.open;
        });

        //TODO:: Can we prevent default using MDC functionality?
        $('.mdc-top-app-bar__navigation-icon').click(function (e) {
            e.preventDefault();
        });
    }
}